// src/lib/kinema/core/layers/builtInTypes.ts
import { defineLayerType } from './defineLayerType';

export const VideoLayerType = defineLayerType({
  type: 'video',
  properties: {
    src: { type: 'string', default: '' },
    playbackRate: { type: 'number', default: 1 },
    volume: { type: 'number', default: 1 },
    trimStart: { type: 'number', default: 0 },
    trimEnd: { type: 'number', default: 0 },
    loop: { type: 'boolean', default: false },
  },
  animatable: ['volume', 'opacity', 'x', 'y', 'scaleX', 'scaleY', 'rotation'],
});

export const ImageLayerType = defineLayerType({
  type: 'image',
  properties: {
    src: { type: 'string', default: '' },
    objectFit: { type: 'enum', values: ['cover', 'contain', 'fill'], default: 'cover' },
    cropRect: { type: 'object', default: null },
  },
  animatable: ['opacity', 'x', 'y', 'scaleX', 'scaleY', 'rotation'],
});

export const TextLayerType = defineLayerType({
  type: 'text',
  properties: {
    text: { type: 'string', default: '' },
    fontFamily: { type: 'string', default: 'Arial' },
    fontSize: { type: 'number', default: 24 },
    fontWeight: { type: 'number', default: 400 },
    fontStyle: { type: 'string', default: 'normal' },
    color: { type: 'string', default: '#000000' },
    textAlign: { type: 'enum', values: ['left', 'center', 'right'], default: 'center' },
    verticalAlign: { type: 'enum', values: ['top', 'middle', 'bottom'], default: 'middle' },
    lineHeight: { type: 'number', default: 1.2 },
  },
  animatable: ['text', 'fontSize', 'color', 'opacity', 'x', 'y', 'scaleX', 'scaleY', 'rotation'],
});

export const ShapeLayerType = defineLayerType({
  type: 'shape',
  properties: {
    shape: { type: 'enum', values: ['rect', 'ellipse', 'path'], default: 'rect' },
    fill: { type: 'string', default: '#ffffff' },
    stroke: { type: 'string', default: 'transparent' },
    strokeWidth: { type: 'number', default: 0 },
    cornerRadius: { type: 'number', default: 0 },
    pathPoints: { type: 'object', default: null },  // PathPoint[] — sole source of truth for path shapes
    pathClosed: { type: 'boolean', default: false },
    trimStart: { type: 'number', default: 0 },   // 0-1, stroke draw-on start
    trimEnd: { type: 'number', default: 1 },     // 0-1, stroke draw-on end
  },
  animatable: ['fill', 'stroke', 'strokeWidth', 'cornerRadius', 'pathPoints', 'trimStart', 'trimEnd', 'opacity', 'x', 'y', 'scaleX', 'scaleY', 'rotation', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY', 'shadowOpacity'],
});

export const AudioLayerType = defineLayerType({
  type: 'audio',
  renderable: false,
  properties: {
    src: { type: 'string', default: '' },
    volume: { type: 'number', default: 1 },
    trimStart: { type: 'number', default: 0 },
    trimEnd: { type: 'number', default: 0 },
    loop: { type: 'boolean', default: false },
  },
  animatable: ['volume'],
});

export const CompositionLayerType = defineLayerType({
  type: 'composition',
  canHaveChildren: true,
  properties: {
    duration: { type: 'number', default: 10 },
    frameRate: { type: 'number', default: 24 },
    background: { type: 'string', default: '' },
  },
  animatable: ['opacity', 'x', 'y', 'scaleX', 'scaleY', 'rotation'],
});

export const builtInLayerTypes = [
  VideoLayerType,
  ImageLayerType,
  TextLayerType,
  ShapeLayerType,
  AudioLayerType,
  CompositionLayerType,
];
